import {Routes, RouterModule} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {LoginComponent} from './login/login.component';
import {HomeComponent} from './home/home.component';
import {UserComponent} from './user/user.component';
import {ProfileComponent} from './profile/profile.component';
import {CompanyComponent} from './company/company.component';
import {AccountComponent} from './account/account.component';
import {DeviceComponent} from './device/device.component';
import {ProtocolComponent} from './protocol/protocol.component';
import {DeviceTypeComponent} from './device-type/device-type.component';
import {UserDeviceComponent} from './user-device/user-device.component';
import {PositionHistoryComponent} from './position-history/position-history.component';
import {GeofenceComponent} from './geofence/geofence.component';
import {PositionReportComponent} from './position-report/position-report.component';
import {StoppedTimeReportComponent} from './stopped-time-report/stopped-time-report.component';
import {DistanceTraveledReportComponent} from './distance-traveled-report/distance-traveled-report.component';
import {FuelConsumptionReportComponent} from './fuel-consumption-report/fuel-consumption-report.component';
import {TravelReportComponent} from './travel-report/travel-report.component';
import {ExcessSpeedReportComponent} from './excess-speed-report/excess-speed-report.component';
import {LeisureReportComponent} from './leisure-report/leisure-report.component';
import {AlarmReportComponent} from './alarm-report/alarm-report.component';
import {
    DrivingOutsideHoursReportComponent
} from './driving-outside-hours-report/driving-outside-hours-report.component';
import {StatusReportComponent} from './status-report/status-report.component';
import {SchedulingReportComponent} from './scheduling-report/scheduling-report.component';
import {BinnacleComponent} from './binnacle/binnacle.component';
import {AlarmTypeComponent} from './alarm-type/alarm-type.component';
import {AlarmComponent} from './alarm/alarm.component';
import {InterestPointComponent} from './interest-point/interest-point.component';
import {AddressComponent} from './address/address.component';
import {HierarchyComponent} from './hierarchy/hierarchy.component';
import {DriverComponent} from './driver/driver.component';
import {TravelDriverReportComponent} from './travel-driver-report/travel-driver-report.component';
import {AlarmDriverReportComponent} from './alarm-driver-report/alarm-driver-report.component';
import {DeviceWithoutReportingComponent} from './device-without-reporting/device-without-reporting.component';
import {MonitoringComponent} from './monitoring/monitoring.component';
import {MaintenanceTypeComponent} from './maintenance-type/maintenance-type.component';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {ViolationReportComponent} from './violation-report/violation-report.component';
import {SummaryInfractionReportComponent} from './summary-infraction-report/summary-infraction-report.component';
import {
    SummaryDistanceTraveledReportComponent
} from './summary-distance-traveled-report/summary-distance-traveled-report.component';
import {
    SummaryInfranctionsByDayReportComponent
} from './summary-infranctions-by-day-report/summary-infranctions-by-day-report.component'
import {CommandReportComponent} from './command-report/command-report.component';
import {GeofenceReportComponent} from './geofence-report/geofence-report.component';

export const routes: Routes = [
    {path: 'home', component: HomeComponent},
    {path: 'login', component: LoginComponent},
    {path: 'user', component: UserComponent},
    {path: 'profile', component: ProfileComponent},
    {path: 'company', component: CompanyComponent},
    {path: 'account', component: AccountComponent},
    {path: 'device', component: DeviceComponent},
    {path: 'protocol', component: ProtocolComponent},
    {path: 'deviceType', component: DeviceTypeComponent},
    {path: 'userDevice', component: UserDeviceComponent},
    {path: 'positionHistory', component: PositionHistoryComponent},
    {path: 'geofence', component: GeofenceComponent},
    {path: 'positionReport', component: PositionReportComponent},
    {path: 'stoppedTimeReport', component: StoppedTimeReportComponent},
    {path: 'distanceTraveledReport', component: DistanceTraveledReportComponent},
    {path: 'fuelConsumptionReport', component: FuelConsumptionReportComponent},
    {path: 'travelReport', component: TravelReportComponent},
    {path: 'excessSpeedReport', component: ExcessSpeedReportComponent},
    {path: 'leisureReport', component: LeisureReportComponent},
    {path: 'alarmReport', component: AlarmReportComponent},
    {path: 'drivingOutsideHoursReport', component: DrivingOutsideHoursReportComponent},
    {path: 'statusReport', component: StatusReportComponent},
    {path: 'schedulingReport', component: SchedulingReportComponent},
    {path: 'binnacle', component: BinnacleComponent},
    {path: 'alarm', component: AlarmComponent},
    {path: 'alarmType', component: AlarmTypeComponent},
    {path: 'interestPoint', component: InterestPointComponent},
    {path: 'address', component: AddressComponent},
    {path: 'hierarchy', component: HierarchyComponent},
    {path: 'driver', component: DriverComponent},
    {path: 'commandReport', component: CommandReportComponent},
    {path: 'travelDriverReport', component: TravelDriverReportComponent},
    {path: 'alarmDriverReport', component: AlarmDriverReportComponent},
    {path: 'deviceWithoutReporting', component: DeviceWithoutReportingComponent},
    {path: 'monitoring', component: MonitoringComponent},
    {path: 'maintenanceType', component: MaintenanceTypeComponent},
    {path: 'maintenance', component: MaintenanceComponent},
    {path: 'violationReport', component: ViolationReportComponent},
    {path: 'summaryInfractionReport', component: SummaryInfractionReportComponent},
    {path: 'summaryDistanceTraveledReport', component: SummaryDistanceTraveledReportComponent},
    {path: 'summaryInfranctionsByDayReport', component: SummaryInfranctionsByDayReportComponent},
    {path: 'geofenceReport', component: GeofenceReportComponent}
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts